export class Profile {
  name: string = '';
  lastname: string = '';
  email: string = '';
  password: string = '';
  confirm: string = '';
  avatar: string | null = null;
}
